<template>
  <div v-if="npc" class="person" :class="`person--${name}`" :style="`--npcwidth: ${npc.Width}px; --npcbottom: ${npc.Bottom}px;`">
    <div v-if="hasSprites" class="person__inner">
      <!-- stand (right) -->
      <img
        v-for="count in 4"
        :key="`ls-${count - 1}`"
        :alt="name"
        :src="npc.RightStand[count - 1] ? npc.RightStand[count - 1] : npc.RightStand[0]"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'VillageNpc2',

  props: {
    npcs: {
      default: () => {},
      type: [Array, Object]
    }
  },

  computed: {
    npc () {
      if (this.npcs) {
        return this.npcs
      }
      return null
    },
    hasSprites () {
      if (this.npc) {
        if (
          this.npc.RightStand.length > 2
        ) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      name: 'npc'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/mixins.scss';

$delay: 2.5s;
$duration: .7s;
.person--npc {
  display: none;
  bottom: 68px;
  bottom: calc(84px - var(--npcbottom));
  left: 53%;
  width: 0;
  width: var(--npcwidth);

  @include breakpoint(md) {
    display: block;
  }

  @media only screen and (max-height: 440px) and (orientation: landscape) {
    bottom: 38px;
    bottom: calc(54px - var(--npcbottom));
  }

  .person__inner {
    transform: translate3d(0, 0, 0);
    animation: npc-animate $duration steps(1) infinite $delay;

    img {
      width: var(--npcwidth);
      min-width: var(--npcwidth);
    }
  }
}
@keyframes npc-animate {
  0% {
    transform: translate3d(0, 0, 0);
  }
  33.333% {
    transform: translate3d(calc(var(--npcwidth) * -1), 0, 0);
  }
  66.666% {
    transform: translate3d(calc(var(--npcwidth) * -2), 0, 0);
  }
  100% {
    transform: translate3d(calc(var(--npcwidth) * -3), 0, 0);
  }
}
</style>
